const styles = theme => ({
  inputFormControl: {
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    visibility: 'visible',
    '& > .MuiFormControlLabel-label': {
      color: theme.palette.primary.foreground,
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '27px',
    },
  },
  checkboxRoot: {
    padding: 0,
    margin: 0,
    '& .MuiIconButton-label': {
      position: 'relative',
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },
  checkboxChecked: {
    color: theme.palette.primary.main,
  },
  checkboxIntermediate: {
    color: theme.palette.primary.main,
  },
});
export default styles;
